<app-navbar-style-two></app-navbar-style-two>

<!-- ============================= -->
<!-- PRODUCTS SHOP SECTION -->
<!-- ============================= -->
<section class="projects-section shop-page">

    <!-- HEADER -->
    <div class="section-header" *ngFor="let Content of projectsContent">

        <span class="section-tag">🧸 Toy Box</span>
 
        <h1 class="section-title">
            {{Content.title}}
        </h1>

        <p class="section-description">
            {{Content.paragraph}}
        </p>

    </div>

    <div class="container">

        <!-- ===================================== -->
        <!-- MOBILE FILTER TOGGLE BAR -->
        <!-- ===================================== -->
        <div class="mobile-filter-bar">

            <button class="mobile-filter-toggle" (click)="mobileFilterOpen = !mobileFilterOpen">
                <i class="bx bx-filter-alt"></i>
                Filters
            </button>

            <div class="mobile-sort-inline">
                <select [(ngModel)]="sortOption" (change)="sortProducts()">
                    <option value="default">Sort: Default</option>
                    <option value="lowToHigh">Price: Low–High</option>
                    <option value="highToLow">Price: High–Low</option>
                    <option value="nameAsc">Name: A–Z</option>
                    <option value="nameDesc">Name: Z–A</option>
                </select>
            </div>

            <div class="mobile-results">
                <strong>{{filteredProjects.length}}</strong> items
            </div>

        </div>

        <!-- ===================================== -->
        <!-- MOBILE FILTER DRAWER BACKDROP -->
        <!-- ===================================== -->
        <div class="drawer-backdrop" [class.open]="mobileFilterOpen" (click)="mobileFilterOpen = false"></div>

        <div class="shop-layout">

            <!-- ===================================== -->
            <!-- LEFT SIDEBAR FILTERS -->
            <!-- ===================================== -->
            <aside class="shop-sidebar" [class.drawer-open]="mobileFilterOpen">

                <!-- Mobile drawer header -->
                <div class="drawer-header">
                    <span>🎯 Filters</span>
                    <button class="drawer-close" (click)="mobileFilterOpen = false">
                        <i class="bx bx-x"></i>
                    </button>
                </div>

                <div class="filter-card">

                    <div class="search-box">

                        <i class="bx bx-search"></i>

                        <input type="text" placeholder="Search products..." [(ngModel)]="searchText"
                            (input)="applyFilters()">

                    </div>

                </div>

                <div class="filter-card">

                    <button class="clear-filter-btn" (click)="clearAllFilters()">

                        <i class="bx bx-refresh"></i>
                        Clear All Filters

                    </button>

                </div>

                <!-- CATEGORY FILTER -->
                <div class="filter-card">

                    <div class="filter-header" (click)="toggleCategories()">

                        <h3 class="filter-title">
                            🧩 Categories
                        </h3>

                        <i class="bx bx-chevron-down" [class.rotate-icon]="showCategories">
                        </i>

                    </div>

                    <div class="collapse-content" [class.expanded]="showCategories">

                        <div *ngFor="let category of projectCategories" class="filter-item"
                            [class.active]="selectedCategory === category.id" (click)="selectCategory(category.id)">

                            {{ category.name }}

                        </div>

                    </div>

                </div>


                <!-- BRAND FILTERS -->
                <div class="filter-card">

                    <div class="filter-header" (click)="toggleBrands()">

                        <h3 class="filter-title">
                            🏷️ Brands
                        </h3>

                        <i class="bx bx-chevron-down" [class.rotate-icon]="showBrands">
                        </i>

                    </div>

                    <div class="collapse-content" [class.expanded]="showBrands">

                        <label *ngFor="let brand of brands" class="checkbox-item">

                            <input type="checkbox" [value]="brand.brand_name"
                                (change)="toggleBrand($event, brand.brand_name)">

                            <span>
                                {{ brand.brand_name }}
                            </span>

                        </label>

                    </div>

                </div>

                <!-- PRICE FILTER -->
                <div class="filter-card">

                    <h3 class="filter-title price-title">
                        💰 Price Range
                    </h3>

                    <div class="price-range">

                        <input type="range" min="0" max="10000" [(ngModel)]="maxPrice" (change)="applyFilters()">

                        <div class="price-values">
                            ₹0 — ₹{{maxPrice}}
                        </div>

                    </div>

                </div>

                <!-- AVAILABILITY -->
                <div class="filter-card availability-card">

                    <h3 class="filter-title">
                        📦 Availability
                    </h3>

                    <label class="checkbox-item">

                        <input type="checkbox" [(ngModel)]="inStockOnly" (change)="applyFilters()">

                        <span>In Stock Only</span>

                    </label>

                </div>

                <!-- Mobile apply button -->
                <div class="drawer-apply">
                    <button class="apply-filter-btn" (click)="mobileFilterOpen = false">
                        <i class="bx bx-check"></i>
                        Apply Filters
                    </button>
                </div>

            </aside>

            <!-- ===================================== -->
            <!-- RIGHT CONTENT -->
            <!-- ===================================== -->
            <div class="shop-content">

                <!-- DESKTOP TOPBAR -->
                <div class="shop-topbar">

                    <!-- RESULTS -->
                    <div class="results-count">

                        Showing
                        <strong>{{filteredProjects.length}}</strong>
                        Products

                    </div>

                    <!-- SORT -->
                    <div class="sort-box">

                        <select [(ngModel)]="sortOption" (change)="sortProducts()">

                            <option value="default">
                                Default Sorting
                            </option>

                            <option value="lowToHigh">
                                Price: Low to High
                            </option>

                            <option value="highToLow">
                                Price: High to Low
                            </option>

                            <option value="nameAsc">
                                Name: A-Z
                            </option>

                            <option value="nameDesc">
                                Name: Z-A
                            </option>

                        </select>

                    </div>

                </div>

                <!-- ===================================== -->
                <!-- PRODUCT GRID -->
                <!-- ===================================== -->
                <div class="products-grid" *ngIf="filteredProjects.length > 0">

                    <div class="product-card" *ngFor="let project of pagedProjects">

                        <!-- IMAGE -->
                        <div class="product-image">

                            <img [src]="project.image" [alt]="project.title" (error)="onImageError($event)">

                            <!-- BADGES -->
                            <div class="product-badge">
                                New
                            </div>

                            <!-- QUICK ACTIONS -->
                            <div class="product-actions">

                                <!-- QUICK VIEW -->
                                <button class="action-btn" data-bs-toggle="modal" data-bs-target="#quickViewModal"
                                    (click)="openQuickView(project)">

                                    <i class='bx bx-show'></i>

                                </button>

                                <!-- WISHLIST -->
                                <button class="action-btn" (click)="toggleWishlist(project)">

                                    <i class='bx bx-heart'></i>
                                </button>

                            </div>

                        </div>

                        <!-- CONTENT -->
                        <div class="product-content">

                            <!-- BRAND -->
                            <span class="brand-name">
                                {{project.brand || 'Premium Toys'}}
                            </span>

                            <!-- TITLE -->
                            <h3 (click)="openProduct(project.id)">
                                {{project.title}}
                            </h3>

                            <!-- PRICE -->
                            <div class="price-row">

                                <div class="price">
                                    ₹{{project.price}}
                                </div>

                                <div class="rating">
                                    ⭐ 4.8
                                </div>

                            </div>

                            <!-- FOOTER -->
                            <div class="product-footer">

                                <!-- QUANTITY -->
                                <div class="qty-box">

                                    <button (click)="decreaseQuantity(project)">
                                        −
                                    </button>

                                    <span>
                                        {{project.quantity}}
                                    </span>

                                    <button (click)="increaseQuantity(project)">
                                        +
                                    </button>

                                </div>

                                <!-- ADD TO CART -->
                                <button class="cart-btn" (click)="addToCart(project)">

                                    <i class='bx bx-cart'></i>
                                    Add

                                </button>

                            </div>

                        </div>

                    </div>

                </div>

                <!-- ===================================== -->
                <!-- EMPTY -->
                <!-- ===================================== -->
                <div class="empty-state" *ngIf="filteredProjects.length === 0">

                    <div class="empty-icon">
                        🧸
                    </div>

                    <h3>No Toys Found</h3>

                    <p>
                        Try adjusting your filters or search something else.
                    </p>

                    <button class="empty-reset-btn" (click)="clearAllFilters()">
                        <i class="bx bx-refresh"></i>
                        Reset Filters
                    </button>

                </div>

                <!-- ===================================== -->
                <!-- PAGINATION -->
                <!-- ===================================== -->
                <div class="pagination-wrapper" *ngIf="totalPages > 1">

                    <button class="page-btn prev-next" [disabled]="currentPage === 1"
                        (click)="changePage(currentPage - 1)">
                        <i class="bx bx-chevron-left"></i>
                        Prev
                    </button>

                    <button *ngFor="let page of pages" class="page-btn" [class.active]="page === currentPage"
                        (click)="changePage(page)">
                        {{page}}
                    </button>

                    <button class="page-btn prev-next" [disabled]="currentPage === totalPages"
                        (click)="changePage(currentPage + 1)">
                        Next
                        <i class="bx bx-chevron-right"></i>
                    </button>

                </div>

            </div>

        </div>

    </div>

</section>

<!-- ===================================== -->
<!-- QUICK VIEW MODAL -->
<!-- ===================================== -->
<div class="modal fade" id="quickViewModal" tabindex="-1">

    <div class="modal-dialog modal-dialog-centered modal-lg">

        <div class="modal-content quick-modal">

            <div class="modal-body" *ngIf="selectedProduct">

                <button class="btn-close" data-bs-dismiss="modal">
                </button>

                <div class="row align-items-center">

                    <!-- IMAGE -->
                    <div class="col-lg-6">

                        <div class="quick-image">

                            <img [src]="selectedProduct.image" [alt]="selectedProduct.title">

                        </div>

                    </div>

                    <!-- CONTENT -->
                    <div class="col-lg-6">

                        <div class="quick-content">

                            <span class="quick-brand">
                                Premium Toys
                            </span>

                            <h2>
                                {{selectedProduct.title}}
                            </h2>

                            <div class="quick-price">
                                ₹{{selectedProduct.price}}
                            </div>

                            <p>
                                {{selectedProduct.description}}
                            </p>

                            <button class="quick-cart-btn" (click)="addToCart(selectedProduct)">

                                <i class="bx bx-cart"></i>
                                Add To Cart

                            </button>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>

</div>